import axios from "axios";
import {
    RATING_REQUEST,
    RATING_SUCCESS,
    RATING_FAIL,
    RATING_CLEAR_ERRORS
} from "../Constants/ratin_const";


export const get_rating_scale = () => async (dispatch) => {
  try {
    dispatch({
      type: RATING_REQUEST,
    });
    const rate = await axios.get(
      `${process.env.REACT_APP_API_URL}/survey/rating/`
    );
    dispatch({
      type: RATING_SUCCESS,
      payload: rate,
    });
  } catch (error) {
    dispatch({
      type: RATING_FAIL,
      payload: error.response,
    });
  }
};

export const update_rating_scale =
  (rating_payload, id) => async (dispatch) => {
    try {
      dispatch({
        type: RATING_REQUEST,
      });
      await axios.put(
        `${process.env.REACT_APP_API_URL}/survey/rating/${id}/`,
        rating_payload
      );
      const communication = await axios.get(
        `${process.env.REACT_APP_API_URL}/survey/rating/`
      );

      dispatch({
        type: RATING_SUCCESS,
        payload: communication,
      });
    } catch (error) {
      dispatch({
        type: RATING_FAIL,
        payload: error.response,
      });
    }
  };



  export const add_rating_scale =
    (rating_payload) => async (dispatch) => {
      try {
        dispatch({
          type: RATING_REQUEST,
        });
        await axios.post(
          `${process.env.REACT_APP_API_URL}/survey/rating/`,
          rating_payload
        );
        const communication = await axios.get(
          `${process.env.REACT_APP_API_URL}/survey/rating/`
        );
  
        dispatch({
          type: RATING_SUCCESS,
          payload: communication,
        });
      } catch (error) {
        dispatch({
          type: RATING_FAIL,
          payload: error.response,
        });
      }
    };
export const rating_clearErrors = () => async (dispatch) => {
  dispatch({
    type: RATING_CLEAR_ERRORS,
  });
};
